import React from 'react';
import { Analytics } from '@vercel/analytics/react';
import { TenantProvider } from '../contexts/TenantContext';
import { SocketProvider } from '../contexts/SocketContext';
import { ThemeProvider } from './ThemeProvider';
import App from '../App';

/**
 * Enhanced App wrapper with multi-tenant support
 * Provides TenantContext, SocketContext, and ThemeProvider
 */
const EnhancedApp: React.FC = () => {
  return (
    <TenantProvider>
      <ThemeProvider>
        <SocketProvider>
          <App />
          <Analytics />
        </SocketProvider>
      </ThemeProvider>
    </TenantProvider>
  );
};

export default EnhancedApp;